import { getToken } from "../api";

const BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

const request = async (method, path, body) => {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: { "Content-Type": "application/json", "x-auth-token": getToken() },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Request failed");
  return data;
};

export const advanceOrderItem = (orderId, lineId, productionStatus) =>
  request("PUT", `/api/orders/${orderId}/items/${lineId}/production-status`, { productionStatus });

export const cancelOrderItem = (orderId, lineId, reason, operationId) =>
  request("PUT", `/api/orders/${orderId}/items/${lineId}/cancel`, { reason, operationId });

export const refundOrderItem = (orderId, lineId, amount, reason, operationId) =>
  request("PUT", `/api/orders/${orderId}/items/${lineId}/refund`, { amount, reason, operationId });

export const refundOrderOverpayment = (orderId, amount, reason, operationId) =>
  request("PUT", `/api/orders/${orderId}/settlement-refund`, { amount, reason, operationId });

export const salvageOrderItem = (orderId, lineId, data, operationId) =>
  request("POST", `/api/orders/${orderId}/items/${lineId}/salvage`, { ...data, operationId });

export const applyCustomerCredit = (orderId, targetType, targetId, amount, operationId) =>
  request("POST", `/api/orders/${orderId}/apply-credit`, { targetType, targetId, amount, operationId });
